class CautivaAnnouncementBar extends HTMLElement {
  #abortController;

  connectedCallback() {
    const storageKey = this.dataset.storageKey;
    if (storageKey && this.#isDismissed(storageKey)) {
      this.hidden = true;
      return;
    }

    const dismissButton = this.querySelector('.cautiva-announcement__dismiss');
    if (!dismissButton) return;

    this.#abortController = new AbortController();
    dismissButton.addEventListener('click', () => this.#dismiss(storageKey), {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #isDismissed(key) {
    try {
      return window.localStorage.getItem(key) === 'dismissed';
    } catch {
      return false;
    }
  }

  #dismiss = (key) => {
    if (key) {
      try {
        window.localStorage.setItem(key, 'dismissed');
      } catch {}
    }
    this.hidden = true;
  };
}

if (!customElements.get('cautiva-announcement-bar')) {
  customElements.define('cautiva-announcement-bar', CautivaAnnouncementBar);
}
